module.exports = __webpack_public_path__ + "img/IT0000207618963.14c17f58.png";